<template>
  <div>
    <ul class="list" :class="listCssClass"
      :style="listStyle">
      <li
        v-for="(item, index) of items"
        ref="item"
        :key="index"
        :class="{ on: item.isOn, lastItem: index === items.length - 1}"
        @mouseenter="onItemHover(item, true)"
        @mouseleave="onItemHover(item, false)"
        @transitionend="onItemTransitionEnd(item, item.isOn)">
        <component :is="componentName"
          :dataType="dataType"
          :itemIndex="index"
          :item="item"
          :isFirstItem="index === 0"
          :isLastItem="index === items.length - 1"
          :pathItem="pathItems[index]"
          :countData="countData"
          @onShowFlowClick="onShowFlowClick"
          @onConversionClick="onConversionClick"
        />
      </li>
    </ul>
  </div>
</template>

<script>
import FunnelsItemTypeA from './FunnelsItemTypeA'
import FunnelsItemTypeB from './FunnelsItemTypeB'
import FunnelsItemTypeC from './FunnelsItemTypeC'

export default {
  name: 'FunnelsItem',
  components: {
    FunnelsItemTypeA,
    FunnelsItemTypeB,
    FunnelsItemTypeC
  },
  props: [
    'items',
    'pathItems',
    'isCompactMode',
    'scrollIndex',
    'dataType',
    'countData'
  ],
  data () {
    return {
      isMounted: false
    }
  },
  computed: {
    itemSize () {
      return this.items.length
    },
    isMiniType () {
      return this.isCompactMode && this.itemSize >= 12
    },
    componentName () {
      const itemSize = this.itemSize

      if (itemSize <= 3) {
        return 'FunnelsItemTypeA'
      } else {
        if (this.isCompactMode) {
          if (this.isMiniType) {
            return 'FunnelsItemTypeC'
          } else {
            return 'FunnelsItemTypeC'
          }
        } else {
          return 'FunnelsItemTypeB'
        }
      }
    },
    listCssClass () {
      const itemSize = this.itemSize
      const value = {
        'c_bType': this.isCompactMode,
        miniType: this.isMiniType,
        aType: false,
        flickType: false
      }

      if (!this.isCompactMode) {
        if (itemSize > 3) {
          value.aType = true
        }
        if (itemSize > 5) {
          value.flickType = true
        }
      }
      return value
    },
    listStyle () {
      if (this.isCompactMode || !this.isMounted) {
        return null
      }
      const itemWidth = this.$refs.item[0].offsetWidth
      const transform = `translateX(-${itemWidth * this.scrollIndex}px)`
      return {
        transform,
        overflow: 'visible',
        'transition-duration': '0.5s'
      }
    }
  },
  mounted () {
    this.isMounted = true
  },
  methods: {
    onItemHover (item) {

    },
    onItemTransitionEnd (item) {

    },
    onShowFlowClick (item) {
      this.$emit('onShowFlowClick', item)
    },
    onConversionClick (item, isDropped, isConverted) {
      this.$emit('onConversionClick', item, isDropped, isConverted)
    }
  }
}
</script>

<style lang="scss" scoped>
//상단끝 컨텐츠 시작 이게 기본값
.list {
  overflow: hidden;
  min-width: 1170px;
  margin-top: 15px;
  margin-right: 30px;
  display: flex;
  background-color: #fff;
  border-radius: 12px 12px 12px 12px;
  box-shadow: 0 23px 15px -12px rgba(0, 0, 0, 0.08);
  background-color: #fff;
  //리스트시작
  /deep/ li {
    position: relative;
    flex-grow: 1;
    flex-shrink: 1;
    flex-basis: 0;
    padding: 30px 0;
    border-top:1px solid rgba(0, 0, 0, 0.08);
    border-bottom:1px solid rgba(0, 0, 0, 0.08);
    background-color: #fff;
    transition: all 0.2s;
    &:before {
      content: "";
      position: absolute;
      top: 0;
      right: 0;
      width: 1px;
      height: 100%;
      opacity: 0.08;
      background-color: #000;
      z-index: 1;
    }
    &:first-child{
      border-radius: 12px 0 0 12px;
      border-left:1px solid rgba(0, 0, 0, 0.08);
    }
    &:last-child {
      border-radius: 0 12px 12px 0;
      border-right:1px solid rgba(0, 0, 0, 0.08);
      .txt_percent {
        color: #289eef;
      }
      .txt_num {
        color: #289eef;
      }
    }
    &:last-child:before {
      content: none;
    }
  }
}
//컴포넌트 디폴트
.list {
  //component 시작
  //상단 step 텍스트 부분
  /deep/ .funnels__text--wrap {
    // height:221px;
    padding: 0 25px 25px;
    .text-step--wrap {
      display: flex;
      position: relative;
      .title {
        font-size: 18px;
        color: #444;
        flex-shrink: 0;
      }
      .txt--desc {
        overflow: hidden;
        position: relative;
        height: 36px;
        align-items: center;
        margin-left: 10px;
        padding-left: 10px;
        font-size: 15px;
        line-height: 17px;
        color: #444;
        word-break: break-all;
        &:before {
          content: "";
          position: absolute;
          top: 2px;
          left: 0;
          width: 1px;
          height: 14px;
          background-color: #d7d7d7;
        }
      }
      .stop-alert {
        top: 31px;
        left: -41px
      }
      .icon--stop {
        vertical-align: middle;
        margin-right: 5px;
      }
    }
    .step__info--wrap {
      // overflow:hidden;
      display: flex;
      margin-top: 25px;
    }
    .img_thumb {
      width: 140px;
      height: 140px;
      border-radius: 5px;
      box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.12),
        0 4px 7px -2px rgba(0, 0, 0, 0.3);
      background-color: #d8d8d8;
      background-repeat: no-repeat;
      background-position: 50% 50%;
      background-size: cover;
    }
    .info_data {
      position: relative;
      align-self: flex-end;
      padding-left: 25px;
    }
    .badge_icon {
      position: absolute;
      top: -23px;
      left: 30px;
      margin-top: -3px;
      text-align: center;
      border-radius: 4px;
      background-color: #289eef;
      font-size: 12px;
      color: #fff;
      padding: 3px 5px;
    }
    .txt_percent {
      display: block;
      font-size: 44px;
      line-height: 44px;
      color: #1199af;
      .txt_item {
        font-size: 34px;
      }
    }
    .txt_num {
      display: block;
      margin: 4px 0 0 5px;
      font-size: 17px;
      line-height: 17px;
      color: #1199af;
      .txt_desc {
        font-size: 12px;
      }
    }

    .link_share {
      margin-top: 15px;

      &.b-type {
        overflow: visible;

        & > .text {
          display: inline-block;
          width: 100%;
          height: 100%;
        }

        & + .bubble {
          bottom: 104px;
          left: 151px;
          transform: translateX(-50%);
        }
      }
    }
  }
  /deep/ .box--data__wrap {
    position: relative;

    .box--wrap {
      width: 46px;
      height: 24px;
      margin-top: -12px;
      position: absolute;
      top: 50%;
      left: 40px;
      color: #fff;
      line-height: 24px;
      text-align: center;
      border-radius: 6px;
      background-color: #7fa900;
    }
    .box--wrap_type2 {
      background-color: #007a8e;
    }
  }

  // 아래 컴포넌트 시작
  /deep/ .view__info--wrap {
    // height:108px;
    display: flex;
    padding: 18px 25px 0;
    flex-wrap: wrap;
    .info__wrap {
      align-self: flex-end;
      .link_info {
        overflow: hidden;
        display: block;
        line-height: 36px;
        color: #444;
        text-align: center;
        border-radius: 20px;
        border: 1px solid #bbb;
        background-color: #fff;
        width: 92px;
        &:hover {
          @include hoverStyle;
        }
      }
      .link_converted {
        margin-top: 43px;
        border: 1px solid #289eef;
        color: #289eef;
        width: auto;
      }
      .link_info + .link_info {
        margin-top: 5px;
      }
      .disable {
        opacity: 0.3;
        pointer-events: none;
      }
    }
    .status--wrap {
      position: relative;
      margin-top: -12px;
      margin-left: 68px;
      padding-left: 46px;
      color: #ff4a00;

      .status_icon {
        position: absolute;
        top: 0;
        left: 0;
        width: 40px;
        background-position: center center;
      }
      .icon--arrow_s {
        width: 30px;
        // left:12px;
      }
      .status_desc {
        display: block;
        font-size: 15px;
      }
      .status_num {
        display: block;
        margin-top: 5px;
        font-size: 30px;
      }
      .status_total {
        display: block;
        margin-top: 5px;
        font-size: 15px;
      }
      .status_add {
        font-size: 12px;
      }
    }
  }
}

//3개 이상
.list.aType {
  /deep/ .view__info--wrap {
    .info__wrap {
      margin-left: 31px;
    }
  }
  /deep/ li {
    .text-step--wrap {
      align-items: baseline;
      .num {
        font-size: 18px;
        color: #444;
      }
      .txt--desc {
        margin-left: 6px;
        padding-left: 0;
        font-size: 15px;
        color: #444;
        &:before {
          content: none;
        }
      }
    }
    .step__info--wrap {
      flex-direction: column;
    }
    .link_share {
      position: absolute;
      bottom: 57px;
      left: 133px;
      margin-top: 0px;
      padding: 8px;
      // 공유 아이콘 인던트 버전
      .txt {
        position: absolute;
        overflow: hidden;
        clip: rect(0 0 0 0);
        margin: -1px;
        width: 1px;
        height: 1px;
      }
      &:hover:after {
        display: inline-block;
        content: "";
        width: 100%;
        height: 100%;
        background-color: #000;
        position: absolute;
        top: 0;
        left: 0;
        opacity: 0.06;
        border-radius: 50%;
      }
      &:hover {
        @include hoverStyle;
      }
    }
    .info_data {
      display: flex;
      position: relative;
      align-self: baseline;
      padding-left: 0;
      margin-top: 18px;
      height: 41px;
    }
    .badge_icon {
      left: 11px;
    }
    .img_thumb {
      width: 120px;
      height: 120px;
      border-radius: 5px;
      box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.12),
        0 4px 7px -2px rgba(0, 0, 0, 0.3);
      background-color: #d8d8d8;
      background-repeat: no-repeat;
      background-position: 50% 50%;
      background-size: cover;
    }
    .txt_percent {
      white-space: nowrap;
      font-size: 38px;
      line-height: 40px;
    }
    .txt_num {
      position: relative;
      margin-left: 10px;
      padding-left: 10px;
      font-size: 13px;
      line-height: 16px;
      .txt_desc {
        display: block;
        white-space: nowrap;
        // font-size:12px;
      }
      &:before {
        content: "";
        position: absolute;
        top: 2px;
        left: 0;
        width: 1px;
        height: 26px;
        background-color: #d7d7d7;
      }
    }
    .view__info--wrap {
      align-items: flex-end;
    }
    .status--wrap {
      margin-left: 0;
      padding-right: 16px;
      padding-left: 0;
      .status_icon {
        right: -15px;
        top: 0;
        left: auto;
        width: 25px;
        height: 31px;
        background-size: 25px auto;
        background-repeat: no-repeat;
      }
      .status_desc {
        font-size: 13px;
      }
      .status_num {
        font-size: 22px;
        .txt {
          font-size: 16px;
        }
      }
      .status_total {
        font-size: 13px;
        line-height: 17px;
      }
      .status_add {
        display: block;
      }
    }
    .info__wrap {
      .link_info {
        position: relative;
        display: block;
        width: 62px;
        padding: 2px 6px;
        line-height: 14px;
        color: #444;
        text-align: left;
        border: 0;
        &:after {
          content: "";
          position: absolute;
          top: 2px;
          right: 0;
          width: 14px;
          height: 14px;
          background: url(../../assets/img/funnel/funnel_arrow_icon.svg)
            no-repeat;
        }
        .icon--converted {
          display: inline-block;
          margin-right: 8px;
          vertical-align: middle;
        }
      }
      .link_converted {
        border: 1px solid #289eef;
        color: #289eef;
        margin-top: 27px;
        width: auto;
        padding-left: calc(11px + 16px + 8px);
        padding-right: 13px;
        &:after {
          content: none;
        }
      }
      .link_info + .link_info {
        margin-top: 5px;
      }
    }
  }
  li.lastItem {
    /deep/ .view__info--wrap {
      justify-content: flex-end;
    }
  }
}

// 6개짜리
.list.flickType {
  margin-right: 0;
  border-radius: 12px 0 0 12px;
  /deep/ li {
    flex-basis: 19.8%;
    flex-shrink: 0;
  }
}
// 축소모드
.list.c_bType {
  overflow: visible;

  /deep/ li {
    .funnels__text--wrap {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      align-self: center;
      padding-left:0;
      padding-right:0;
    }
    .step__info--wrap {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      margin-top: 20px;
      .info_data {
        min-width: 74px;
        padding-left: 0;
        text-align: center;
        .badge_icon {
          left: 50%;
          top: 0;
          transform: translateX(-50%);
          width: 90px;
        }
      }
      .txt_percent {
        margin-top: 15px;
        font-size: 26px;
        .txt_item {
          margin-left:-5px;
          font-size: 26px;
        }
      }
    }
    .text-step--wrap {
      height: initial;
      .num {
        font-size: 18px;
      }
    }
    .stop-alert {
      left: auto;
      top: 61px;
    }
    .link_share {
      margin: 0;
      padding: 8px;
    }
    .view__info--wrap {
      display: flex;
      flex-direction: column;
      justify-content: center;
      padding-left:0;
      padding-right:0;
      .status--wrap {
        width: 100%;
        margin: 0;
        padding: 0;
        text-align: center;
        .status_icon {
          position: static;
          display: block;
          margin: 0 auto;
        }
        .status_num {
          font-size: 16px;
        }
      }
      .info__wrap {
        margin-top: 37px;
        align-self: center;
        .link_info {
          position: relative;
          display: block;
          width: 62px;
          padding: 2px 6px;
          line-height: 14px;
          color: #444;
          text-align: left;
          border: 0;
          &:after {
            content: "";
            position: absolute;
            top: 2px;
            right: 0;
            width: 14px;
            height: 14px;
            background: url(../../assets/img/funnel/funnel_arrow_icon.svg)
              no-repeat;
          }
        }
        .link_converted {
          content: none;
          display: inline-block;
          width: 84px;
          margin-top: 63px;
          text-align: center;
          border-radius: 20px;
          color: #289eef;
          &:after {
            content: none;
          }
        }
        .icon--converted {
          display: inline-block;
          margin-right: 5px;
          vertical-align: top;
        }
      }
    }
    .img_thumb {
      width: 74px;
      height: 74px;
      transform: scale(1);
    }
  }
}
// 6개짜리
.list.miniType {
  overflow: initial;
  /deep/ li {
    width: 4%;
    flex-shrink: 0;
    &:first-child {
      border-radius: 12px 0 0 12px;
    }
    .funnels__text--wrap {
      padding: 0;
    }
    .box--data__wrap {
      height: 100px;
    }
    .step__info--wrap {
      position: relative;
      text-align: center;
      z-index: 1;
      .img_thumb {
        visibility: hidden;
        &:hover {
          transform: scale(1.5);
          transition: all 0.3s;
        }
      }
      .img_thumb:hover + .info_data .txt_percent {
        transform: scale(1.5);
        transition: all 0.3s;
      }
      .txt_percent {
        font-size: 16px;
        .txt_item {
          font-size: 16px;
        }
      }
      .img_thumb:hover + .info_data .badge_icon {
        transform: scale(1.5) translateX(-33%);
        transition: all 0.3s;
      }
      .info_data {
        .badge_icon {
          z-index: 1;
        }
      }
    }
    .link_share {
      visibility: hidden;
    }
    .info__wrap {
      visibility: hidden;
    }
    .view__info--wrap {
      margin-top: 18px;
      padding: 0;
      .icon--arrow_l {
        width: 20px;
        height: 25px;
        background-size: 20px auto;
      }
      .icon--arrow_m {
        width: 20px;
        height: 25px;
        background-size: 20px auto;
      }
      .icon--arrow_s {
        width: 20px;
        height: 25px;
        background-size: 20px auto;
      }
    }
    &:hover {
      flex-grow: 1.8;
      z-index: 10;
      .step__info--wrap {
        .img_thumb,
        .txt_percent {
          visibility: inherit;
        }
      }
      .link_share {
        visibility: inherit;
      }
      .info__wrap {
        visibility: inherit;
      }
    }
  }
}
</style>
